module.exports = __webpack_public_path__ + "img/pekao.4c0c29db.png";